import { useEffect, useRef } from "react";

export const useOutsideClick = (callback) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const handleClick = (event) => {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        callback(event); // Trigger the provided callback
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [callback]);

  return elementRef;
};
